import './form.css';
export default {
  "button": "pf-v6-c-button",
  "dirRtl": "pf-v6-m-dir-rtl",
  "form": "pf-v6-c-form",
  "formActions": "pf-v6-c-form__actions",
  "formFieldGroup": "pf-v6-c-form__field-group",
  "formFieldGroupBody": "pf-v6-c-form__field-group-body",
  "formFieldGroupHeader": "pf-v6-c-form__field-group-header",
  "formFieldGroupHeaderActions": "pf-v6-c-form__field-group-header-actions",
  "formFieldGroupHeaderDescription": "pf-v6-c-form__field-group-header-description",
  "formFieldGroupHeaderMain": "pf-v6-c-form__field-group-header-main",
  "formFieldGroupHeaderTitle": "pf-v6-c-form__field-group-header-title",
  "formFieldGroupHeaderTitleText": "pf-v6-c-form__field-group-header-title-text",
  "formFieldGroupToggle": "pf-v6-c-form__field-group-toggle",
  "formFieldGroupToggleButton": "pf-v6-c-form__field-group-toggle-button",
  "formFieldGroupToggleIcon": "pf-v6-c-form__field-group-toggle-icon",
  "formFieldset": "pf-v6-c-form__fieldset",
  "formGroup": "pf-v6-c-form__group",
  "formGroupControl": "pf-v6-c-form__group-control",
  "formGroupLabel": "pf-v6-c-form__group-label",
  "formGroupLabelHelp": "pf-v6-c-form__group-label-help",
  "formGroupLabelInfo": "pf-v6-c-form__group-label-info",
  "formGroupLabelMain": "pf-v6-c-form__group-label-main",
  "formHelperText": "pf-v6-c-form__helper-text",
  "formLabel": "pf-v6-c-form__label",
  "formLabelRequired": "pf-v6-c-form__label-required",
  "formLabelText": "pf-v6-c-form__label-text",
  "formSection": "pf-v6-c-form__section",
  "formSectionTitle": "pf-v6-c-form__section-title",
  "modifiers": {
    "horizontal": "pf-m-horizontal",
    "alignRight": "pf-m-align-right",
    "noPaddingTop": "pf-m-no-padding-top",
    "info": "pf-m-info",
    "horizontalOnXs": "pf-m-horizontal-on-xs",
    "horizontalOnSm": "pf-m-horizontal-on-sm",
    "horizontalOnMd": "pf-m-horizontal-on-md",
    "horizontalOnLg": "pf-m-horizontal-on-lg",
    "horizontalOnXl": "pf-m-horizontal-on-xl",
    "horizontalOn_2xl": "pf-m-horizontal-on-2xl",
    "limitWidth": "pf-m-limit-width",
    "action": "pf-m-action",
    "disabled": "pf-m-disabled",
    "inline": "pf-m-inline",
    "stack": "pf-m-stack",
    "inactive": "pf-m-inactive",
    "hidden": "pf-m-hidden",
    "expanded": "pf-m-expanded",
    "expandable": "pf-m-expandable"
  }
};